import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { getTenantName, getTenantPerson, Tenant } from '../../../models/tenant.model';
import { DataTableColumn, PaginatorStatus } from '../../generics/data-table/data-table.component';
import { UtilsService } from 'src/app/services/utils.service';
import { Currency } from 'src/app/models/currency.model';
import { CustomTableFilter } from '../../generics/table-filter/table-filter.component';
import { CurrencyService } from 'src/app/services/currency.service';
import { ErrorResponse } from 'src/app/models/error.model';

@Component({
    selector: 'app-currency',
    templateUrl: './currency.component.html',
    styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
        buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Código moneda', prop: 'codigo', sortable: true },
        { name: 'Descripción', prop: 'descripcion', sortable: true, },
        { name: 'Símbolo', prop: 'simbolo', sortable: true },
        { name: '', width: '130px' }
    ];

    filters: CustomTableFilter[] = [
        { key: 'codigoMoneda', description: 'Código moneda', type: 'STRING' },
        { key: 'descripcion', description: 'Descripción', type: 'STRING' },
    ];


    filterValues: any = {};

    currencies: Currency[];


    constructor(
        private utilsService: UtilsService,
        private currencyService: CurrencyService,
    ) {

    }

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getCurrencies();
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        // this.getCurrencies();
    }

    getCurrencies() {
        this.currencyService.getCurrency().subscribe({
            next: response => {
                this.currencies = response;
            },
            error: (error: ErrorResponse) => {
                this.utilsService.alert('Error al obtener las monedas', error.error.descripcion);
            }
        });
    }
}
